/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
import { ChangeEvent, useState } from 'react';
import * as z from 'zod/v4';
import { notify } from '../services/toastService';
import { AxiosHttp } from '../services/axiosService';
import { API_NEWS_URL } from '../constants';

interface IFormResponse {
    status_code: number;
    message: string;
    body?: Array<unknown>;
}

export function useForms<TSchema extends z.ZodObject<z.ZodRawShape>>(
    schema: TSchema,
    initialData: z.infer<TSchema>
) {
    const [formData, setFormData] = useState<z.infer<TSchema>>(initialData);

    const [validFields, setValidFields] = useState<Record<keyof z.infer<TSchema>, boolean>>(
        Object.keys(initialData).reduce((acc, key) => ({ ...acc, [key]: true }), {} as any)
    );

    const handleFormChange = (
        e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
    ) => {
        const { name, value } = e.target;

        let nextVal = value;
        if (name === 'phone') {
            nextVal = value
                .replace(/[^\d+]/g, '') // mantém dígitos e '+'
                .replace(/(?!^)\+/g, ''); // remove '+' fora do início
        }

        setFormData((prev) => ({
            ...prev,
            [name]: nextVal, // <-- usar nextVal aqui
        }));
    };

    const validateForms = () => {
        const result = schema.safeParse(formData);

        if (!result.success) {
            const fieldErrors = result.error.issues;

            const updatedValidFields = {} as Record<keyof z.infer<TSchema>, boolean>;

            for (const error of fieldErrors) {
                const key = error.path[0];
                updatedValidFields[key as keyof z.infer<TSchema>] = false;
            }

            setValidFields(updatedValidFields);
            return false;
        }

        setValidFields(
            Object.keys(formData).reduce(
                (acc, key) => {
                    acc[key as keyof z.infer<TSchema>] = true;
                    return acc;
                },
                {} as Record<keyof z.infer<TSchema>, boolean>
            )
        );
        return true;
    };

    const resetForms = () => {
        setFormData(
            Object.keys(initialData).reduce((acc, key) => ({ ...acc, [key]: '' }), {} as any)
        );
    };

    const handleEmitForm = async (url: string) => {
        try {
            if (!validateForms()) {
                notify.error('Preencha os campos em destaque e tente novamente!');
                return;
            }

            const apiRequest = new AxiosHttp(API_NEWS_URL);
            const response = await apiRequest.post<IFormResponse>(url, formData);
            notify.success(response.message);
            resetForms();

            // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err: any) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access

            notify.error(`${String(err)}`);
        }
    };

    return {
        formData,
        validFields,
        handleFormChange,
        validateForms,
        handleEmitForm,
    };
}
